import React, { Component } from 'react'
import { Table, Tooltip } from 'antd'
import Preloader from '../../common/Preloader'
import NewHeader from '../../common/NewHeader'
import SideNav from '../../common/SideNav'
import ResultModal from '../../common/Modals/AddClinicHospital'
import NewFooter from '../../common/NewFooter'
import ajax from '../../utils/ajax';
import functions from '../../utils/functions'
import BillOrders from '../../common/Modals/BillOrders'
import OrderParkaging from '../../common/Modals/OrderParkaging'


class Parkaging extends Component {

    state = {
        userId: functions.sessionGuard(),
        review: false,
        dialog: false,
        isActive: false,
        hospitalsList: false,
        hosId: "",
        prescriptionId:"",
        presciptionImage:""
        
    };

    componentDidMount() {
        this.getAllPendingPrescriptions();
    }

    recievedStateReview = (data) => {
        this.setState({ billing: data })
    }

    onClickRegister = () => {
      this.setState({ dialog: true })
    }

    recievedState = (data) => {
      this.setState({ dialog: data })
    }

    getAllPendingPrescriptions = async () => {
        const server_response = await ajax.listOrderByStageAt(this.state.userId,"2");
        const tableData = []

        if (server_response.status === "OK") {
            //  console.log("lplplplplplplplooo",server_response.details.content.list)
            server_response.details.content.map((pending) =>
                tableData.push({
                    clientName: pending.client.full_name,
                    clientPhone: pending.client.phone_number,
                    prescriptionName: pending.prescription.pres_name,
                    prescriptionid: pending.prescription.pres_id,
                    prescriptionimage:pending.prescription.pres_photo,
                    prescriptionStatus: pending.prescription.verify_status,
                    created: pending.created_at.long_date,
                    actioned: pending.prescription.pres_id, //prescription_id
                    clientId:pending.client.client_id,
                    orderId:pending.order_id

                }),
            )

            this.setState({
               hospitalsList: tableData
            })

        } else {
            //   this.setState({
            //     hospitalsList: "404"
            //   })
        }
    }

    onClickReview = (client,order, presciptionImage) => {
        this.setState({
            billing: true,
            clientId:client,
            orderId:order,
            presciptionImage:presciptionImage
        })
    }

    render() {

        const columns = [
            {
                title: 'Client Name',
                dataIndex: 'clientName',
            },
            {
                title: 'Client Phone',
                dataIndex: 'clientPhone',
            },
            {
                title: 'Precription Name',
                dataIndex: 'prescriptionName',
            },
            {
                title: 'Precription ID',
                dataIndex: 'prescriptionid',
                hidden: true
            },
            {
                title: 'Client ID',
                dataIndex: 'clientId',
                hidden: true
            },
            {
                title: 'Order ID',
                dataIndex: 'orderId',
                hidden: true
            },
            {
                title: 'Precription Image',
                dataIndex: 'prescriptionimage',
                hidden: true
            },
            {
                title: 'Order Date',
                dataIndex: 'created',
            },
            {
                title: 'Actions - [ View ]',
                dataIndex: 'actioned',

                className: 'bg-transparent text-right',
                render: (text, records, index) => {
                    return (
                        <div className="text-nowrap">
                            <Tooltip
                                placement="leftTop"
                                title="View to take action "
                                color="#454B1B"
                                key="#f50"
                                style={{ marginRight: "10px" }}
                            >
                                <button
                                    type="button"
                                    className="btn btn-light text-red"
                                    style={{ marginInlineEnd: "10px" }}
                                    onClick={() => this.onClickReview(records.clientId,records.orderId, records.prescriptionimage)}                                >
                                    View Order <i className="fa fa-eye" />
                                </button>

                            </Tooltip>

                        </div>
                    )
                }
            },

        ].filter(item => !item.hidden)

        return (

            <body>
                {/* <!-- begin app --> */}
                <div class="app">
                    {/* <!-- begin app-wrap --> */}
                    <div class="app-wrap">
                        {/* <!-- begin pre-loader --> */}
                        <Preloader />
                        <NewHeader />
                        <div class="app-container">
                            <SideNav />
                            {/* <!-- begin app-main --> */}
                            <div class="app-main" id="main">
                                {/* <!-- begin container-fluid --> */}
                                <div class="container-fluid">
                                    {/* <!-- begin row --> */}
                                    <div class="row">
                                        <div class="col-md-12 m-b-30">
                                            {/* <!-- begin page title --> */}
                                            <div class="d-block d-sm-flex flex-nowrap align-items-center">
                                                <div class="page-title mb-2 mb-sm-0">
                                                    <h1>Park And Dispatch Orders</h1>
                                                </div>
                                                <div class="ml-auto d-flex align-items-center">
                                                    <nav>
                                                        <ol class="breadcrumb p-0 m-b-0">
                                                            <li class="breadcrumb-item">
                                                                <a href="index.html"><i class="ti ti-home"></i></a>
                                                            </li>
                                                            <li class="breadcrumb-item">
                                                                Order Processing
                                                            </li>
                                                            <li class="breadcrumb-item active text-primary" aria-current="page">Park and dispatch</li>
                                                        </ol>
                                                    </nav>
                                                </div>
                                            </div>
                                            {/* <!-- end page title --> */}
                                        </div>
                                    </div>
                                    {/* <!-- end row --> */}
                                    {/* <!-- begin row --> */}
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="card card-statistics">
                                                <div class="card-body">

                                                    <div class="datatable-wrapper table-responsive">

                                                        <Table
                                                            columns={columns}
                                                            bordered
                                                            dataSource={this.state.hospitalsList}
                                                            size="small"
                                                            pagination={{ pageSizeOptions: ['10'], showTitle: false, hideOnSinglePage: false }}

                                                        />

                                                        {this.state.dialog ? (
                                                        <ResultModal
                                                            visible={{ visible: true }}
                                                            handleCancel={this.recievedState}
                                                        />
                                                        ) : null}  

                                                        {this.state.billing ? (
                                                            <OrderParkaging
                                                                visible={{ visible: true, orderId: this.state.orderId,clientId:this.state.clientId, presImage: this.state.presciptionImage}}
                                                                handleCancel={this.recievedStateReview}
                                                            />
                                                        ) : null}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- end row --> */}
                                </div>
                                {/* <!-- end container-fluid --> */}
                            </div>
                            {/* <!-- end app-main --> */}
                        </div>
                        {/* <!-- end app-container --> */}
                        <NewFooter />
                    </div>
                    {/* <!-- end app-wrap --> */}
                </div>
                {/* <!-- end app --> */}
            </body>

        )
    }
}
export default Parkaging